<div *ngIf="message"
  class="mt-2"
  [ngClass]="{ 'alert': message, 'alert-success': message.type === 'success', 'alert-danger': message.type === 'error', 'alert-warning': message.type === 'warning' } ">
  <button type="button" class="btn-close" aria-label="Close" (click)="message=null">
    <span aria-hidden="true">&times;</span>
  </button>
  {{message.text}}
</div>

